var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 21V13.75C11.25 13.5511 11.329 13.3603 11.4697 13.2197C11.6103 13.079 11.8011 13 12 13C12.1989 13 12.3897 13.079 12.5303 13.2197C12.671 13.3603 12.75 13.5511 12.75 13.75V21H13.7798C13.9708 21 14.154 21.079 14.2891 21.2197C14.4241 21.3603 14.5 21.5511 14.5 21.75C14.5 21.9489 14.4241 22.1397 14.2891 22.2803C14.154 22.421 13.9708 22.5 13.7798 22.5H10.2202C10.0292 22.5 9.84598 22.421 9.71093 22.2803C9.57587 22.1397 9.5 21.9489 9.5 21.75C9.5 21.5511 9.57587 21.3603 9.71093 21.2197C9.84598 21.079 10.0292 21 10.2202 21H11.25Z",
    fill: "#33DAFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 14,
    rx: 3.5,
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2361 12C10.0277 12 9.82777 11.9246 9.68038 11.7903C9.53299 11.656 9.4502 11.4739 9.4502 11.284V6.71599C9.45422 6.52725 9.53831 6.34723 9.68484 6.21374C9.83136 6.08025 10.0289 6.00367 10.2361 6H12.4682C12.7613 6 13.0515 6.0526 13.3223 6.15479C13.5931 6.25698 13.8392 6.40673 14.0464 6.59555C14.2537 6.78437 14.4181 7.00855 14.5303 7.25525C14.6425 7.50196 14.7002 7.76636 14.7002 8.03339C14.7002 8.30042 14.6425 8.56486 14.5303 8.81156C14.4181 9.05827 14.2537 9.2824 14.0464 9.47122C13.8392 9.66004 13.5931 9.80984 13.3223 9.91203C13.0515 10.0142 12.7613 10.0668 12.4682 10.0668H11.0221V11.284C11.0221 11.4739 10.9392 11.656 10.7918 11.7903C10.6445 11.9246 10.4446 12 10.2361 12ZM11.0221 8.63484H12.4682C12.5549 8.63484 12.6407 8.61926 12.7208 8.58904C12.8009 8.55882 12.8737 8.51453 12.935 8.45868C12.9963 8.40283 13.0449 8.33653 13.0781 8.26356C13.1113 8.19059 13.1283 8.11237 13.1283 8.03339C13.1283 7.87388 13.0588 7.72093 12.935 7.60814C12.8112 7.49535 12.6433 7.43198 12.4682 7.43198H11.0221V8.63484Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainParking);
export default __webpack_public_path__ + "static/media/main-parking.bb86fa6498d898ecbe7b8ed07642179b.svg";
export { ForwardRef as ReactComponent };